/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash';
import {
  GET_ADMIN_UNSEEN_NOTIFICATION_COUNT,
  GET_ADMIN_UNSEEN_NOTIFICATION_COUNT_SUBSCRIPTION,
} from 'utils/CommonGraphQL';
import { useQuery } from '@apollo/client';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notificationCount, setNotificationCount] = useState(null);
  const { data, subscribeToMore, refetch } = useQuery(
    GET_ADMIN_UNSEEN_NOTIFICATION_COUNT,
    {
      pollInterval: 10000,
    },
  );

  useEffect(() => {
    if (data?.getAdminUnseenNotificationCount) {
      setNotificationCount(data?.getAdminUnseenNotificationCount);
    }
  }, [data]);

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: GET_ADMIN_UNSEEN_NOTIFICATION_COUNT_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        return subscriptionData.data;
      },
    });
    return () => unsubscribe();
  }, []);

  const contextValue = useMemo(
    () => ({
      notificationCount,
      setNotificationCount,
      refetchNotificationCount: refetch,
    }),
    [notificationCount, refetch],
  );

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  return useContext(NotificationContext);
};
